import { NgModule } from '@angular/core';
import { GraphComponentComponent } from './graph-component/graph-component.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { LinqOverviewComponent } from './overview-panel/overview.component';
import { LinqYFilesExportService } from './yfiles-canvas-export.service';
import { MaterialModule } from '../material/material.module';
import { ToolbarButtonsComponent } from './toolbar/toolbar-buttons.component';
import { ToolbarButtonComponent } from './toolbar/toolbar-button.component';
import { MiniGraphComponent } from './mini-graph/mini-graph.component';
import { GraphService } from './graph.service';
import { TutorialGraphComponent } from './tutorial-graph/tutorial-graph.component';
import { NodePaletteComponent } from './palette/node-palette.component';
import { ModelIntroductionService } from '../animations/model-introduction';
import { UIComponentsModule } from '../ui-components/ui-components.module';

@NgModule({
  declarations: [
    GraphComponentComponent,
    ToolbarComponent,
    LinqOverviewComponent,
    ToolbarButtonsComponent,
    ToolbarButtonComponent,
    MiniGraphComponent,
    TutorialGraphComponent,
    NodePaletteComponent
  ],
  exports: [
    GraphComponentComponent,
    LinqOverviewComponent,
    ToolbarComponent,
    MiniGraphComponent,
    ToolbarButtonsComponent,
    TutorialGraphComponent,
    NodePaletteComponent
  ],
  imports: [
    MaterialModule,
    UIComponentsModule
  ],
  providers: [
    LinqYFilesExportService,
    GraphService,
    ModelIntroductionService
  ]
})
export class LinqCanvasModule { }
